import { css } from 'linaria';

export const sponsoredHover = css`
  &:hover {
    background-color: var(--background-secondary);
  }
`;

export const promoLabel = css`
  position: absolute;
  top: 0;
  left: var(--space-200);
  transform: translateY(-50%);
`;

export const suggestionsList = css`
  &.dividers {
    &::before {
      left: var(--space-800);
    }
    &::after {
      left: var(--space-200);
    }
  }
`;
